import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '~/auth/Auth'
import { useCommunity } from '~/contexts/CommunityContext'
import { GetUserCommunitiesDocument } from '~/api/generated/graphql'
import { useQuery } from '@apollo/client'

const ManageMembersLink = () => {
  const { authUserId, isVeevan, profileVisible } = useAuth()
  const { communityId } = useCommunity()
  const { data } = useQuery(GetUserCommunitiesDocument, { variables: { id: authUserId ?? '' }, skip: !authUserId })
  const leadershipIds = useMemo(
    () => data?.user?.memberships?.edges?.filter(e => e?.node?.leader).map(e => e?.node?.communityId ?? null) || [],
    [data]
  )
  const isLeader = useMemo(() => leadershipIds.includes(communityId), [leadershipIds, communityId])

  if (!profileVisible) return null

  return (
    <div>
      {isVeevan && isLeader && (
        <p>
          To manage members, go to the{' '}
          <Link to={'../members'} className={'manage-members-link'}>
            Members tab
          </Link>
        </p>
      )}
    </div>
  )
}

export default ManageMembersLink
